const unitConverter = require('convert-units')
const temperatureConverter = require('temp-units-conv')

const UnitsService = (module.exports = {})

const unitSystemFrom = (locale = 'en', settings) => {
  let toUnitSystem = 'SI'
  if (settings && settings.massUnit) {
    toUnitSystem = settings.massUnit
  } else if (locale && locale.indexOf('en') === 0) {
    toUnitSystem = 'IMPERIAL'
  }
  return toUnitSystem
}

UnitsService.unitSystemFrom = unitSystemFrom

UnitsService.massInUserSettings = function(massInKg, locale, settings, opts) {
  const toUnitSystem = unitSystemFrom(locale, settings)
  return UnitsService.massFromKilogramToUnitSystem(massInKg, toUnitSystem, opts)
}

UnitsService.sizeInUserSettings = function(sizeInCM, locale, settings, opts) {
  const toUnitSystem = unitSystemFrom(locale, settings)
  return UnitsService.sizeFromCentimetersToUnitSystem(sizeInCM, toUnitSystem, opts)
}

UnitsService.temperatureInUserSettings = function(temperatureInDegreeCelsius, locale, settings, opts) {
  const toUnitSystem = unitSystemFrom(locale, settings)
  return UnitsService.temperatureFromCelsiusToUnitSystem(temperatureInDegreeCelsius, toUnitSystem, opts)
}

// toUnitSystem must be 'SI' or 'IMPERIAL'. default to 'SI'
// massInKG must be... in kg
// returns the mass in kg for SI or in lbs for IMPERIAL
UnitsService.massFromKilogramToUnitSystem = function(massInKG, toUnitSystem, opts) {
  if (!massInKG) {
    return massInKG
  }
  let toUnit
  switch (toUnitSystem) {
    case 'SI':
      toUnit = 'kg'
      break
    case 'IMPERIAL':
      toUnit = 'lb'
      break
    default:
      toUnit = 'kg'
      break
  }
  opts = opts || {
    withUnit: false,
  }
  return (
    unitConverter(massInKG)
      .from('kg')
      .to(toUnit)
      .toLocaleString(undefined, { maximumFractionDigits: 2, useGrouping: false }) + (opts.withUnit ? ` ${toUnit}` : '')
  )
}

// takes a mass in lbs in arg, return it in kg
UnitsService.massInKGFromLBS = function(massInLBS) {
  return unitConverter(massInLBS)
    .from('lb')
    .to('kg')
}

// toUnitSystem must be 'SI' or 'IMPERIAL'. default to 'SI'
// distanceInCentimeters must be... in centimeters
// returns the distance in centimeters for SI or in inches for IMPERIAL
UnitsService.sizeFromCentimetersToUnitSystem = function(distanceInCentimeters, toUnitSystem, opts) {
  if (!distanceInCentimeters) {
    return distanceInCentimeters
  }
  let toUnit
  switch (toUnitSystem) {
    case 'SI':
      toUnit = 'cm'
      break
    case 'IMPERIAL':
      toUnit = 'in'
      break
    default:
      toUnit = 'cm'
      break
  }
  opts = opts || {
    withUnit: false,
  }
  return (
    unitConverter(distanceInCentimeters)
      .from('cm')
      .to(toUnit)
      .toLocaleString(undefined, { maximumFractionDigits: 2, useGrouping: false }) + (opts.withUnit ? ` ${toUnit}` : '')
  )
}

// taks a size in inches and returns its value in centimeters
UnitsService.sizeInCentimetersFromInches = function(sizeInInches) {
  return unitConverter(sizeInInches)
    .from('in')
    .to('cm')
}

// passing 'SI' as toUnitSystem will return in Celsius, passing 'IMPERIAL' will return in fahrenheit
UnitsService.temperatureFromCelsiusToUnitSystem = function(temperatureInCelsius, toUnitSystem, opts) {
  opts = opts || { withUnit: false }
  if (!temperatureInCelsius) {
    return temperatureInCelsius
  }
  let result
  let toUnit = '°C'
  switch (toUnitSystem) {
    case 'SI':
      result = temperatureInCelsius
      break
    case 'IMPERIAL':
      toUnit = '°F'
      result = temperatureConverter.c2f(temperatureInCelsius)
      break
    default:
      result = temperatureInCelsius
  }
  return (
    result.toLocaleString(undefined, { maximumFractionDigits: 0, useGrouping: false }) +
    (opts.withUnit ? ` ${toUnit}` : '')
  )
}

UnitsService.temperatureInCelsiusFromFahrenheit = function(temperatureInFahrenheit) {
  return temperatureConverter.fahrenheitToCelsius(temperatureInFahrenheit)
}

UnitsService.speedFromMeterPerSecondToUnitSystem = function(speedInMeterPerSec, toUnitSystem) {
  let inUnitPerSec
  switch (toUnitSystem) {
    case 'IMPERIAL':
      inUnitPerSec = unitConverter(speedInMeterPerSec)
        .from('m')
        .to('ml')
      break
    default:
      inUnitPerSec = unitConverter(speedInMeterPerSec)
        .from('m')
        .to('km')
      break
  }
  return inUnitPerSec / 3600
}
